import { client } from './client';

export const validateBankAccount = (bankAccountDetails, requestConfig = {}) =>
  client('paymentmethods/directdebits/verification', {
    ...requestConfig,
    method: 'POST',
    body: bankAccountDetails
  });

export const getDirectDebitPaymentToken = ({
  sortCode,
  accountNumber,
  accountHolder
}) =>
  client('paymentmethods/directdebits', {
    method: 'POST',
    body: {
      bankAccountName: accountHolder,
      bankSortCode: sortCode,
      bankAccountNumber: accountNumber
    }
  });
